<template>
  <div class="custom-flex custom-justify-center">
    <div v-if="fullscreenZoom" class="custom-margin-right-16" @click="closeFullscreen">
      <img :src="data.resource_url" style="width: 100%;">
    </div>
    <img
      v-else
      :src="data.resource_url"
      :class="['custom-margin-right-16', { zoom: isZoomed }]"
      style="width: 400px; height: auto;"
      ref="image"
      @click="toggleZoom"
    >

    <div class="custom-flex custom-flex-col" v-if="data.resource_url">
      <a-button type="primary" @click="toggleZoom()" class="custom-margin-bottom-10">
        {{ isZoomed ? '恢复' : '放大' }}
      </a-button>

      <a-button type="primary" @click="downloadFile(data.download_url)">
        下载
      </a-button>
    </div>
  </div>
</template>

<script>
import { findServiceOrderConfirmNode } from '@/api/order'

export default {
  name: 'ConfirmNode',
  props: {
    serviceOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      error: null,
      isZoomed: false,
      fullscreenZoom: false,
      isDragging: false,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      scrollTop: 0
    }
  },
  computed: {
  },
  mounted() {
    this.fetchData()
    // 添加键盘事件监听
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    toggleZoom() {
      if (!this.isZoomed) {
        this.isZoomed = true

        // 如果图片较大，使用全屏模式查看
        if (this.$refs.image.naturalWidth > 800 || this.$refs.image.naturalHeight > 600) {
          this.fullscreenZoom = true
        } else {
          // 添加拖动功能
          this.$nextTick(() => {
            this.addDragFunctionality()
          })
        }
      } else {
        this.isZoomed = false
        this.fullscreenZoom = false
        this.removeDragFunctionality()
      }
    },

    closeFullscreen() {
      this.fullscreenZoom = false
      this.isZoomed = false
    },

    addDragFunctionality() {
      const container = this.$refs.imageContainer

      container.addEventListener('mousedown', this.startDrag)
      container.addEventListener('touchstart', this.startDrag, { passive: false })

      window.addEventListener('mousemove', this.drag)
      window.addEventListener('touchmove', this.drag, { passive: false })

      window.addEventListener('mouseup', this.endDrag)
      window.addEventListener('touchend', this.endDrag)
    },

    removeDragFunctionality() {
      const container = this.$refs.imageContainer

      container.removeEventListener('mousedown', this.startDrag)
      container.removeEventListener('touchstart', this.startDrag)

      window.removeEventListener('mousemove', this.drag)
      window.removeEventListener('touchmove', this.drag)

      window.removeEventListener('mouseup', this.endDrag)
      window.removeEventListener('touchend', this.endDrag)
    },

    startDrag(e) {
      if (!this.isZoomed) return

      this.isDragging = true
      const container = this.$refs.imageContainer

      // 记录初始位置
      this.startX = e.pageX || e.touches[0].pageX
      this.startY = e.pageY || e.touches[0].pageY
      this.scrollLeft = container.scrollLeft
      this.scrollTop = container.scrollTop

      // 防止默认行为（如页面滚动）
      e.preventDefault()
    },

    drag(e) {
      if (!this.isDragging) return

      const container = this.$refs.imageContainer
      const x = e.pageX || e.touches[0].pageX
      const y = e.pageY || e.touches[0].pageY

      // 计算移动距离并滚动容器
      const walkX = (x - this.startX) * 2
      const walkY = (y - this.startY) * 2

      container.scrollLeft = this.scrollLeft - walkX
      container.scrollTop = this.scrollTop - walkY
    },

    endDrag() {
      this.isDragging = false
    },

    handleKeydown(e) {
      // ESC键退出全屏或放大模式
      if (e.key === 'Escape') {
        if (this.fullscreenZoom) {
          this.closeFullscreen()
        } else if (this.isZoomed) {
          this.isZoomed = false
          this.removeDragFunctionality()
        }
      }
    },

    fetchData() {
      findServiceOrderConfirmNode(this.serviceOrderId).then(res => {
        if (res.code === 0) {
          this.data = res.data
        }
      })
    },

    downloadFile(url) {
      var x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function(e) {
        var url = window.URL.createObjectURL(x.response)
        var a = document.createElement('a')
        a.href = url
        a.download = '确认单.png'
        a.click()
      }
      x.send()
    }
  }
}
</script>

<style lang="less" scoped>
.zoom {
  transform: scale(1.5);
}
</style>

